// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flight-charges-page {
  padding: 30px;
  background: #f5f5f5;
  min-height: 100vh;
}

.charges-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.charges-header h2 {
  color: #333;
  font-size: 28px;
  font-weight: 600;
  margin: 0;
}

.btn-back {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background-color: #ffeb00;
  color: #000;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-back:hover {
  background-color: #ffd200;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(255, 235, 0, 0.3);
}

.btn-back i {
  font-size: 14px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #666;
  background: #fff;
  border-radius: 8px;
}

.spinner {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #257ecc;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

.spinner-small {
  display: inline-block;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #000;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  animation: spin 0.8s linear infinite;
  margin-right: 8px;
  vertical-align: middle;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.charges-form-wrapper {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.charges-form {
  max-width: 100%;
}

/* All inputs in same row, wrapping at smaller screens */
.form-row-inline {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

/* Ensure all form groups have equal width */
.form-row-inline .form-group {
  min-width: 0; /* Prevent overflow */
}

/* SearchableSelect wrapper styling to match form-control */
.searchable-select-wrapper {
  width: 100%;
}

.searchable-select-wrapper > div {
  width: 100%;
}

/* Override SearchableSelect button to match form-control height */
.searchable-select-wrapper button,
.searchable-select-wrapper > div > div:first-child {
  min-height: 42px;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

/* SearchableSelect wrapper should match form-control styling */
.form-row-inline .form-group > div[class*="relative"] {
  width: 100%;
}

/* When Apply To All is checked, fewer columns still fill naturally */

.checkbox-row {
  display: block;
  margin-top: 10px;
  margin-bottom: 25px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.required {
  color: #e74c3c;
  font-weight: bold;
}

.form-control {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s;
  background: #fff;
}

.form-control:focus {
  outline: none;
  border-color: #257ecc;
  background-color: #fff;
  color: #000;
  box-shadow: 0 0 0 3px rgba(37, 126, 204, 0.1);
}

.form-control:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.checkbox-group {
  margin-top: 0;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-weight: 500;
  color: #333;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #257ecc;
}

.checkbox-text {
  font-size: 15px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.btn {
  padding: 12px 30px;
  border: none;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-submit {
  background-color: #ffeb00;
  color: #000;
  min-width: 120px;
}

.btn-submit:hover:not(:disabled) {
  background-color: #ffd200;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 235, 0, 0.3);
}

.btn-submit:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .form-row-inline {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 767px) {
  .flight-charges-page {
    padding: 15px;
  }

  .charges-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .charges-header h2 {
    font-size: 22px;
  }

  .charges-form-wrapper {
    padding: 20px;
  }

  .form-row-inline {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .btn {
    width: 100%;
  }

  .btn-back {
    width: auto;
  }
}

/* Animation for form submission */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.btn-submit:disabled .spinner-small {
  animation: spin 0.8s linear infinite, pulse 1.5s ease-in-out infinite;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AdminDashboard/components/FlightChargesManagement.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,YAAY,EAAE,qBAAqB;AACrC;;AAEA,2DAA2D;AAC3D;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,kEAAkE;AAClE;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE,WAAW;AACb;;AAEA,qEAAqE;;AAErE;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,qEAAqE;AACvE","sourcesContent":[".flight-charges-page {\n  padding: 30px;\n  background: #f5f5f5;\n  min-height: 100vh;\n}\n\n.charges-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.charges-header h2 {\n  color: #333;\n  font-size: 28px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.btn-back {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background-color: #ffeb00;\n  color: #000;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.btn-back:hover {\n  background-color: #ffd200;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(255, 235, 0, 0.3);\n}\n\n.btn-back i {\n  font-size: 14px;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #666;\n  background: #fff;\n  border-radius: 8px;\n}\n\n.spinner {\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #257ecc;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 15px;\n}\n\n.spinner-small {\n  display: inline-block;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #000;\n  border-radius: 50%;\n  width: 14px;\n  height: 14px;\n  animation: spin 0.8s linear infinite;\n  margin-right: 8px;\n  vertical-align: middle;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.charges-form-wrapper {\n  background: #fff;\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.charges-form {\n  max-width: 100%;\n}\n\n/* All inputs in same row, wrapping at smaller screens */\n.form-row-inline {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n/* Ensure all form groups have equal width */\n.form-row-inline .form-group {\n  min-width: 0; /* Prevent overflow */\n}\n\n/* SearchableSelect wrapper styling to match form-control */\n.searchable-select-wrapper {\n  width: 100%;\n}\n\n.searchable-select-wrapper > div {\n  width: 100%;\n}\n\n/* Override SearchableSelect button to match form-control height */\n.searchable-select-wrapper button,\n.searchable-select-wrapper > div > div:first-child {\n  min-height: 42px;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n/* SearchableSelect wrapper should match form-control styling */\n.form-row-inline .form-group > div[class*=\"relative\"] {\n  width: 100%;\n}\n\n/* When Apply To All is checked, fewer columns still fill naturally */\n\n.checkbox-row {\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 25px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group label {\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.required {\n  color: #e74c3c;\n  font-weight: bold;\n}\n\n.form-control {\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: all 0.3s;\n  background: #fff;\n}\n\n.form-control:focus {\n  outline: none;\n  border-color: #257ecc;\n  background-color: #fff;\n  color: #000;\n  box-shadow: 0 0 0 3px rgba(37, 126, 204, 0.1);\n}\n\n.form-control:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.checkbox-group {\n  margin-top: 0;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-weight: 500;\n  color: #333;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #257ecc;\n}\n\n.checkbox-text {\n  font-size: 15px;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 25px;\n  padding-top: 20px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.btn {\n  padding: 12px 30px;\n  border: none;\n  border-radius: 4px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.btn-submit {\n  background-color: #ffeb00;\n  color: #000;\n  min-width: 120px;\n}\n\n.btn-submit:hover:not(:disabled) {\n  background-color: #ffd200;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(255, 235, 0, 0.3);\n}\n\n.btn-submit:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1200px) {\n  .form-row-inline {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 767px) {\n  .flight-charges-page {\n    padding: 15px;\n  }\n\n  .charges-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n\n  .charges-header h2 {\n    font-size: 22px;\n  }\n\n  .charges-form-wrapper {\n    padding: 20px;\n  }\n\n  .form-row-inline {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .btn {\n    width: 100%;\n  }\n\n  .btn-back {\n    width: auto;\n  }\n}\n\n/* Animation for form submission */\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.btn-submit:disabled .spinner-small {\n  animation: spin 0.8s linear infinite, pulse 1.5s ease-in-out infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
